import { ROUTES } from "../../../../routes";
import { RunBanner } from "../BatchUpdates/RunBanner.js";
import { useOptionalMoveBpaRun } from "./MoveBpaRunProvider.js";

export const MOVE_BPA_PATH = `${ROUTES.developer.pipelineBrowser}?tab=move-bpa`;

type MoveBpaRunBannerProps = {
  onNavigate: (path: string) => void;
};

export function MoveBpaRunBanner({ onNavigate }: MoveBpaRunBannerProps) {
  const run = useOptionalMoveBpaRun();
  if (!run?.running || run.sectionMounted) return null;
  const { dryRun, progress, stop } = run;

  return (
    <RunBanner
      label="Move BPAs run"
      status={`Move BPAs (${dryRun ? "dry run" : "move"}): row ${progress.processedRows} / ${progress.totalRows}.`}
      linkPath={MOVE_BPA_PATH}
      linkLabel="Open Move BPAs"
      onNavigate={onNavigate}
      onStop={stop}
    />
  );
}
